import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import CovidQuestionCard from '@components/CovidQuestionCard';
import PrimaryButton from '@components/PrimaryButton';
import { HeaderLayout } from '@layouts';
import { ROUTES, covidQuestionList } from '@constants';

import { useStyles } from './styles';

function CheckCovidScreen() {
  const [questionList, setQuestionList] = useState(covidQuestionList);
  const [answeredQuestionList, setAnsweredQuestionList] = useState([]);
  const history = useHistory();

  const classes = useStyles();

  const { t } = useTranslation(['checkCovidScreen', 'button']);

  const handleAnswerOnCheckCovidQuestion = ({ id, answer }) => {
    const updatedQuestionList = questionList.map(question => {
      if (question.id === id) {
        return {
          ...question,
          statusQuestion: {
            questionAnswered: true,
            answer,
          },
        };
      }
      return question;
    });

    setQuestionList(updatedQuestionList);
  };

  useEffect(() => {
    const updatedAnsweredQuestionList = questionList
      .filter(question => question.statusQuestion.questionAnswered)
      .map(({ question, statusQuestion }) => ({
        question: question,
        answer: statusQuestion.answer,
      }));

    setAnsweredQuestionList(updatedAnsweredQuestionList);
  }, [questionList]);

  const handleSubmit = () => {
    history.push(ROUTES.SLIDER_SCREEN, {
      from: ROUTES.CHECK_COVID_SCREEN,
    });
  };

  return (
    <HeaderLayout title={t('title')}>
      <>
        <Typography className={classes.subTitle}>{t('subTitle')}</Typography>
        <Box>
          {questionList.map(question => {
            return (
              <CovidQuestionCard
                id={question.id}
                key={question.id}
                srcImg={question.srcImg}
                question={question.questionText}
                statusQuestion={question.statusQuestion}
                handleAnswerOnCheckCovidQuestion={
                  handleAnswerOnCheckCovidQuestion
                }
              />
            );
          })}
        </Box>
        <PrimaryButton
          text={t('button:confirmResult')}
          handleClick={handleSubmit}
          isDisabledButton={questionList.length !== answeredQuestionList.length}
        />
      </>
    </HeaderLayout>
  );
}

export default CheckCovidScreen;
